/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ListingFreelanceCollaborationsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListingFreelanceCollaborationsQuery = {
    __typename: 'Query';
    collaborationsForFreelancer: Array<
        { __typename: 'CollaborationListItem' } & CollaborationListItemFragment
    >;
};

export type CollaborationListItemFragment = {
    __typename: 'CollaborationListItem';
    url: string;
    thumbnailUrl: string;
    title: string;
    description: string;
    status: Types.CollaborationStatus;
    createdAt: any;
    careforceRequestAltId: string;
    slaHours: number;
    expertRequestId: string;
    isLegacy: boolean;
    isReviewEligible: boolean;
    viewerRole: Types.ViewerRole;
    completion: Types.Maybe<{ __typename: 'Completion'; at: any; reason: Types.CompletionReason }>;
    appointment: Types.Maybe<{
        __typename: 'Appointment';
        id: number;
        startTime: any;
        timezone: string;
        zoomMeetingUrl: string;
        durationMinutes: number;
        canBeRescheduled: boolean;
        designerCalendarId: number;
        designerName: string;
        rescheduleUrl: string;
    }>;
    revisions: {
        __typename: 'Revisions';
        isUnlimited: boolean;
        maximum: number;
        remaining: number;
    };
    lastDeliveringDesigner: Types.Maybe<{
        __typename: 'CollaborationParticipant';
        name: string;
        canonicalId: string;
        participantRole: Types.ParticipantRole;
        freelancerId: Types.Maybe<string>;
    }>;
};

export const CollaborationListItemFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CollaborationListItem' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'CollaborationListItem' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completion' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'at' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'careforceRequestAltId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointment' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'zoomMeetingUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'canBeRescheduled' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designerCalendarId' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'rescheduleUrl' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revisions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'isUnlimited' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slaHours' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expertRequestId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLegacy' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isReviewEligible' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastDeliveringDesigner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'participantRole' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'freelancerId' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'viewerRole' } },
                ],
            },
        },
    ],
};
export const ListingFreelanceCollaborationsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ListingFreelanceCollaborations' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collaborationsForFreelancer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'CollaborationListItem' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'CollaborationListItem' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'CollaborationListItem' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'thumbnailUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completion' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'at' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'careforceRequestAltId' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'appointment' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'zoomMeetingUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'durationMinutes' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'canBeRescheduled' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designerCalendarId' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'designerName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'rescheduleUrl' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'revisions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'isUnlimited' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'maximum' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'remaining' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'slaHours' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'expertRequestId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLegacy' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isReviewEligible' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastDeliveringDesigner' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canonicalId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'participantRole' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'freelancerId' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'viewerRole' } },
                ],
            },
        },
    ],
};

/**
 * __useListingFreelanceCollaborationsQuery__
 *
 * To run a query within a React component, call `useListingFreelanceCollaborationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingFreelanceCollaborationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingFreelanceCollaborationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListingFreelanceCollaborationsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        ListingFreelanceCollaborationsQuery,
        ListingFreelanceCollaborationsQueryVariables
    >
) {
    return Apollo.useQuery<
        ListingFreelanceCollaborationsQuery,
        ListingFreelanceCollaborationsQueryVariables
    >(ListingFreelanceCollaborationsDocument, baseOptions);
}
export function useListingFreelanceCollaborationsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ListingFreelanceCollaborationsQuery,
        ListingFreelanceCollaborationsQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        ListingFreelanceCollaborationsQuery,
        ListingFreelanceCollaborationsQueryVariables
    >(ListingFreelanceCollaborationsDocument, baseOptions);
}
export type ListingFreelanceCollaborationsQueryHookResult = ReturnType<
    typeof useListingFreelanceCollaborationsQuery
>;
export type ListingFreelanceCollaborationsLazyQueryHookResult = ReturnType<
    typeof useListingFreelanceCollaborationsLazyQuery
>;
export type ListingFreelanceCollaborationsQueryResult = Apollo.QueryResult<
    ListingFreelanceCollaborationsQuery,
    ListingFreelanceCollaborationsQueryVariables
>;
